/* eslint-disable no-use-before-define */
import { createDealflow, deleteDealflow, updateDealflow } from 'api/dealflow.api';
import { handleHideModal } from 'components/global/_helpers/global.helpers';
import { fetchAndSetDealflowData } from 'components/views/InvestorDealflow/_helpers/investorDealflow.resolvers';
import { $form, $view } from 'signals/global.signals';
import displayError from 'utils/displayError';
import displayNotification from 'utils/displayNotification';
import getSelectValue from 'utils/getSelectValue';

/* ------ CRUD EVENTS ------*/
export const handleSubmitCreateDealflow = async () => {
  $view.update({
    isModalLoading: true,
  });
  try {
    const createData = getFormData();
    await createDealflow({ ...createData, recordType: 'unsynced' });
    handleHideModal();
    await fetchAndSetDealflowData();
  } catch (error) {
    displayError({
      message: 'Failed to create dealflow entry. Please try again.',
      title: 'Creation Error',
    });
  } finally {
    $view.update({
      isModalLoading: false,
    });
  }
};

export const handleSubmitEditDealflow = async () => {
  $view.update({
    isModalLoading: true,
  });
  try {
    const formData = getFormData();
    await updateDealflow($form.value.id, formData);
    displayNotification({
      message: 'Investor updated successfully',
      type: 'success',
    });
    handleHideModal();
    await fetchAndSetDealflowData();
  } catch (error) {
    displayError({
      message: 'Failed to update dealflow entry. Please try again.',
      title: 'Update Error',
    });
  } finally {
    $view.update({
      isModalLoading: false,
    });
  }
};

export const handleSubmitDeleteDealflow = async () => {
  $view.update({
    isModalLoading: true,
  });
  try {
    await deleteDealflow($form.value.id);
    handleHideModal();
    await fetchAndSetDealflowData();
  } catch (error) {
    displayError({
      message: 'Failed to delete dealflow entry. Please try again.',
      title: 'Delete Error',
    });
  } finally {
    $view.update({
      isModalLoading: false,
    });
  }
};

const getFormData = () => ({
  name: $form.value.name,
  description: $form.value.description,
  companyName: $form.value.companyName,
  companyWebsite: $form.value.companyWebsite,
  companyDescription: $form.value.companyDescription,
  contactFirstName: $form.value.contactFirstName,
  contactLastName: $form.value.contactLastName,
  contactEmail: $form.value.contactEmail,
  contactPhone: $form.value.contactPhone,
  contactTitle: $form.value.contactTitle,
  amountInvested: $form.value.amountInvested,
  investmentStage: getSelectValue($form.value.investmentStage),
  typeOfRaise: getSelectValue($form.value.typeOfRaise),
  currentValue: $form.value.currentValue,
  minimumInvestment: $form.value.minimumInvestment,
  currentRaiseSize: $form.value.currentRaiseSize,
  discountPercent: $form.value.discountPercent,
  previouslyCommitted: $form.value.previouslyCommitted,
  interestRate: $form.value.interestRate,
  cap: $form.value.cap,
  amountCommitted: $form.value.amountCommitted,
  pipelineStatus: getSelectValue($form.value.pipelineStatus),
  rating: getSelectValue($form.value.rating),
  teamId: getSelectValue($form.value.teamId),
});
